<lui-alert-lite [level]="props.level" [compact]="true">
  <div class="mat-body" [innerHTML]="props.label"></div>
</lui-alert-lite>
